(function () {
  'use strict';

  var SELECTOR = '[data-charm-builder]';
  var mqDesktop = window.matchMedia('(min-width: 1008px)');

  function normalize(value) {
    return String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
  }

  function parseCount(value, fallback) {
    var match = String(value || '').match(/\d+/);
    return match ? parseInt(match[0], 10) : fallback;
  }

  function isCountName(name) {
    var n = normalize(name);
    return /nombre.*(pendentif|dije)|number.*(charm|pendant)|pocet.*(prives|privesk)|quantit.*(pendentif|charm)|pendentif/.test(n);
  }

  function isColorName(name) {
    var n = normalize(name);
    return /^(color|colour|couleur|colore|farbe|barva)$/.test(n) || n.indexOf('couleur') !== -1;
  }

  function colorKey(value) {
    var n = normalize(value);
    if (/argent|silver|plata|stribr/.test(n)) return 'silver';
    return 'gold';
  }

  function readProduct(root) {
    var script = root.querySelector('[data-product-json]');
    if (!script) return null;
    try { return JSON.parse(script.textContent); } catch (error) { return null; }
  }

  function optionIndex(product, predicate) {
    if (!product || !Array.isArray(product.options)) return -1;
    for (var i = 0; i < product.options.length; i += 1) {
      if (predicate(product.options[i])) return i;
    }
    return -1;
  }

  function currentVariant(productData) {
    if (!productData || !productData.product) return null;
    var id = Number(productData.selected_variant_id);
    return productData.product.variants.find(function (variant) { return Number(variant.id) === id; }) || productData.product.variants[0] || null;
  }

  function optionValue(variant, index) {
    if (!variant || index < 0) return '';
    if (Array.isArray(variant.options)) return variant.options[index] || '';
    return variant['option' + (index + 1)] || '';
  }

  function optionBlock(root, position) {
    if (position < 0) return null;
    var button = root.querySelector('.Popover__Value_nah[data-option-position="' + (position + 1) + '"]');
    return button ? button.closest('.ProductForm__Option') : null;
  }

  function money(cents) {
    var currency = (window.theme && window.theme.shopCurrency) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency', currency: currency, minimumFractionDigits: 0, maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2).replace('.00', '') + ' €';
    }
  }

  function priceFor(product, countIndex, colorIndex, countValue, colorValue) {
    if (!product || !Array.isArray(product.variants)) return null;
    var matches = product.variants.filter(function (variant) {
      if (String(optionValue(variant, countIndex)) !== String(countValue)) return false;
      if (colorIndex >= 0 && colorValue && String(optionValue(variant, colorIndex)) !== String(colorValue)) return false;
      return true;
    });
    if (!matches.length) return null;
    return Math.min.apply(null, matches.map(function (variant) { return Number(variant.price); }));
  }

  function init(builder) {
    if (builder.dataset.charmInitialized === 'true') return;
    builder.dataset.charmInitialized = 'true';

    var form = builder.closest('form.ProductForm') || builder.closest('form[action*="/cart/add"]');
    var root = builder.closest('.Product');
    if (!form || !root) return;

    root.classList.add('Product--charmSelector');
    var wrapper = root.querySelector('.Product__Wrapper');
    var info = root.querySelector('.Product__Info');
    var gallery = root.querySelector('.Product__Gallery');
    var productData = readProduct(root);
    var product = productData && productData.product;
    var countIndex = optionIndex(product, isCountName);
    var colorIndex = optionIndex(product, isColorName);
    var variant = currentVariant(productData);
    var activeColor = colorKey(optionValue(variant, colorIndex));
    var maxCharms = parseInt(builder.dataset.maxCharms, 10) || 4;
    var defaultCount = parseInt(builder.dataset.defaultCount, 10) || 1;
    var rowTemplate = builder.querySelector('[data-charm-row-template]');
    var pickersRoot = builder.querySelector('[data-charm-pickers]');
    var sharedMenu = builder.querySelector('[data-charm-menu]');
    var errorMessage = builder.querySelector('[data-charm-error]');
    var pickers = [];
    var activePicker = null;
    var imageObserver = null;
    var heightFrame = 0;

    if (!rowTemplate || !pickersRoot || !sharedMenu) return;

    for (var i = 1; i <= maxCharms; i += 1) {
      var row = rowTemplate.content.firstElementChild.cloneNode(true);
      var label = row.querySelector('[data-charm-picker-label]');
      var input = row.querySelector('[data-charm-input]');
      var trigger = row.querySelector('[data-charm-trigger]');
      var selectedLabel = row.querySelector('[data-charm-selected-label]');
      var selectedImage = row.querySelector('[data-charm-selected-image]');
      label.textContent = 'PENDENTIF ' + i;
      input.name = 'properties[Pendentif ' + i + ']';
      trigger.setAttribute('aria-label', 'Choisir le pendentif ' + i);
      pickersRoot.appendChild(row);
      pickers.push({ row: row, input: input, trigger: trigger, label: selectedLabel, image: selectedImage, goldSrc: '', silverSrc: '' });
    }

    function selectedCount() {
      return Math.max(1, Math.min(maxCharms, parseCount(optionValue(variant, countIndex), defaultCount)));
    }

    function closeMenu(restoreFocus) {
      if (!activePicker) return;
      activePicker.row.classList.remove('is-open');
      activePicker.trigger.setAttribute('aria-expanded', 'false');
      sharedMenu.hidden = true;
      if (restoreFocus) activePicker.trigger.focus();
      activePicker = null;
    }

    function imageSrc(img) {
      return activeColor === 'silver' ? img.dataset.silverSrc : img.dataset.goldSrc;
    }

    function loadImage(img) {
      var src = imageSrc(img);
      if (!src || img.dataset.currentSrc === src) return;
      img.classList.remove('is-loaded');
      img.onload = function () { img.classList.add('is-loaded'); };
      img.src = src;
      img.dataset.currentSrc = src;
      if (img.complete) img.classList.add('is-loaded');
    }

    function observeMenuImages() {
      var images = sharedMenu.querySelectorAll('.CharmPickerMenu__image');
      if ('IntersectionObserver' in window) {
        if (imageObserver) imageObserver.disconnect();
        imageObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { if (entry.isIntersecting) loadImage(entry.target); });
        }, { root: sharedMenu, rootMargin: '100px 0px' });
        images.forEach(function (img) { imageObserver.observe(img); });
      } else {
        images.forEach(loadImage);
      }
    }

    function refreshLoadedMenuImages() {
      sharedMenu.querySelectorAll('.CharmPickerMenu__image[data-current-src]').forEach(loadImage);
      if (!sharedMenu.hidden) observeMenuImages();
    }

    function refreshPickerImage(picker) {
      var src = activeColor === 'silver' ? picker.silverSrc : picker.goldSrc;
      if (src) {
        picker.image.src = src;
        picker.image.hidden = false;
      } else {
        picker.image.removeAttribute('src');
        picker.image.hidden = true;
      }
    }

    function updateSelectedOptions() {
      var value = activePicker ? activePicker.input.value : '';
      sharedMenu.querySelectorAll('[data-charm-option]').forEach(function (option) {
        option.setAttribute('aria-selected', option.dataset.charmValue === value ? 'true' : 'false');
      });
    }

    function openMenu(picker) {
      if (activePicker === picker && !sharedMenu.hidden) { closeMenu(true); return; }
      closeMenu(false);
      activePicker = picker;
      picker.row.classList.add('is-open');
      picker.trigger.setAttribute('aria-expanded', 'true');
      picker.row.querySelector('[data-charm-control]').appendChild(sharedMenu);
      sharedMenu.hidden = false;
      sharedMenu.scrollTop = 0;
      updateSelectedOptions();
      observeMenuImages();
    }

    pickers.forEach(function (picker) {
      picker.trigger.addEventListener('click', function () { openMenu(picker); });
      picker.trigger.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowDown') {
          event.preventDefault(); openMenu(picker);
          var first = sharedMenu.querySelector('[data-charm-option]');
          if (first) first.focus();
        }
      });
    });

    sharedMenu.addEventListener('click', function (event) {
      var option = event.target.closest('[data-charm-option]');
      if (!option || !activePicker) return;
      activePicker.input.value = option.dataset.charmValue;
      activePicker.label.textContent = option.dataset.charmLabel;
      var img = option.querySelector('.CharmPickerMenu__image');
      activePicker.goldSrc = img.dataset.goldSrc || '';
      activePicker.silverSrc = img.dataset.silverSrc || '';
      refreshPickerImage(activePicker);
      activePicker.row.classList.remove('is-invalid');
      errorMessage.hidden = true;
      closeMenu(true);
      scheduleHeight();
    });

    sharedMenu.addEventListener('keydown', function (event) {
      var options = Array.prototype.slice.call(sharedMenu.querySelectorAll('[data-charm-option]'));
      var index = options.indexOf(document.activeElement);
      if (event.key === 'Escape') { event.preventDefault(); closeMenu(true); }
      if (event.key === 'ArrowDown' && index >= 0) { event.preventDefault(); options[(index + 1) % options.length].focus(); }
      if (event.key === 'ArrowUp' && index >= 0) { event.preventDefault(); options[(index - 1 + options.length) % options.length].focus(); }
    });

    document.addEventListener('click', function (event) {
      if (activePicker && !sharedMenu.contains(event.target) && !activePicker.trigger.contains(event.target)) closeMenu(false);
    });

    function updateRows() {
      var count = selectedCount();
      pickers.forEach(function (picker, index) {
        var visible = index < count;
        picker.row.hidden = !visible;
        picker.input.disabled = !visible;
        picker.row.setAttribute('aria-hidden', visible ? 'false' : 'true');
        if (!visible) picker.row.classList.remove('is-invalid');
      });
      if (activePicker && activePicker.row.hidden) closeMenu(false);
      scheduleHeight();
    }

    function decorateVariantButtons() {
      var countBlock = optionBlock(root, countIndex);
      var colorBlock = optionBlock(root, colorIndex);
      if (countBlock) countBlock.classList.add('CharmBuilderCountOption');
      if (colorBlock) colorBlock.classList.add('CharmBuilderColorOption');

      if (colorBlock) {
        colorBlock.querySelectorAll('.Popover__Value_nah').forEach(function (button) {
          var key = colorKey(button.dataset.value);
          button.style.backgroundImage = 'url("' + (key === 'silver' ? builder.dataset.silverSwatch : builder.dataset.goldSwatch) + '")';
          button.setAttribute('aria-label', button.dataset.value || key);
        });
      }

      if (countBlock && product) {
        var colorValue = optionValue(variant, colorIndex);
        var values = Array.prototype.slice.call(countBlock.querySelectorAll('.Popover__Value_nah')).map(function (button) { return button.dataset.value; });
        var baseValue = values.slice().sort(function (a,b) { return parseCount(a,99) - parseCount(b,99); })[0];
        var basePrice = priceFor(product, countIndex, colorIndex, baseValue, colorValue);
        countBlock.querySelectorAll('.Popover__Value_nah').forEach(function (button) {
          var value = button.dataset.value;
          var count = parseCount(value, value);
          var price = priceFor(product, countIndex, colorIndex, value, colorValue);
          var delta = price !== null && basePrice !== null ? price - basePrice : 0;
          button.textContent = String(count) + (delta > 0 ? ' (+' + money(delta) + ')' : '');
          button.setAttribute('aria-label', value + (delta > 0 ? ', supplément ' + money(delta) : ''));
        });
      }
    }

    function applyVariant(nextVariant) {
      if (nextVariant) variant = nextVariant;
      var nextColor = colorKey(optionValue(variant, colorIndex));
      if (nextColor !== activeColor) {
        activeColor = nextColor;
        refreshLoadedMenuImages();
        pickers.forEach(refreshPickerImage);
      }
      decorateVariantButtons();
      updateRows();
    }

    root.addEventListener('variant:changed', function (event) {
      applyVariant(event.detail && event.detail.variant);
    });

    function validate() {
      var firstInvalid = null;
      pickers.forEach(function (picker) {
        if (picker.input.disabled) return;
        var invalid = !picker.input.value;
        picker.row.classList.toggle('is-invalid', invalid);
        if (invalid && !firstInvalid) firstInvalid = picker;
      });
      errorMessage.hidden = !firstInvalid;
      if (firstInvalid) {
        firstInvalid.trigger.focus();
        firstInvalid.row.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }
      return true;
    }

    form.addEventListener('click', function (event) {
      var submit = event.target.closest('button[type="submit"], [data-action="add-to-cart"]');
      if (submit && !validate()) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
    form.addEventListener('submit', function (event) {
      if (!validate()) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);

    function syncHeight() {
      heightFrame = 0;
      if (!wrapper || !info) return;
      if (!mqDesktop.matches) {
        wrapper.style.minHeight = '';
        return;
      }
      var infoHeight = Math.ceil(info.getBoundingClientRect().height + 24);
      var galleryHeight = gallery ? Math.ceil(gallery.getBoundingClientRect().height) : 0;
      var needed = Math.max(infoHeight, galleryHeight);
      if (needed > 0) wrapper.style.minHeight = needed + 'px';
    }

    function scheduleHeight() {
      if (heightFrame) cancelAnimationFrame(heightFrame);
      heightFrame = requestAnimationFrame(function () { requestAnimationFrame(syncHeight); });
    }

    if ('ResizeObserver' in window) {
      var resizeObserver = new ResizeObserver(scheduleHeight);
      resizeObserver.observe(info);
      if (gallery) resizeObserver.observe(gallery);
    } else {
      window.addEventListener('resize', scheduleHeight, { passive: true });
      window.addEventListener('load', scheduleHeight);
    }
    if (mqDesktop.addEventListener) mqDesktop.addEventListener('change', scheduleHeight);
    else mqDesktop.addListener(scheduleHeight);

    decorateVariantButtons();
    updateRows();
    scheduleHeight();
  }

  function boot(scope) {
    (scope || document).querySelectorAll(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
}());
